import { render, staticRenderFns } from "./browseHistory.vue?vue&type=template&id=4279df87&scoped=true"
import script from "./browseHistory.vue?vue&type=script&lang=js"
export * from "./browseHistory.vue?vue&type=script&lang=js"
import style0 from "./browseHistory.vue?vue&type=style&index=0&id=4279df87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279df87",
  null
  
)

export default component.exports